import * as React from "react";
import type { SVGProps } from "react";
const SvgEdit02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m13.449 6.952 3.6 3.6m-12.6 9 4.366-.88a1.2 1.2 0 0 0 .611-.328l9.774-9.78a1.2 1.2 0 0 0 0-1.697L17.128 4.8a1.2 1.2 0 0 0-1.697.001l-9.775 9.78a1.2 1.2 0 0 0-.327.61z"
    />
  </svg>
);
export default SvgEdit02;
